// src/components/StickyAd.jsx
// 카카오 애드핏 상시 배너 — 앱 전체에서 단 하나, 첫 화면부터 편지 결과까지 계속 고정.
// - 데스크톱(1280px 이상): 좌·우 160x600 레일 (sideLeft/sideRight 광고단위 설정 시)
// - 모바일/미설정 시: 하단 고정 320x100
// FloatingPets(나비)보다 위 레이어(zIndex)에 두고 불투명 배경으로 감싼다.
import { useEffect, useRef, useState } from "react";
import { ADFIT_UNITS } from "../utils/constants";

const WIDE_QUERY = "(min-width: 1280px)";

const hasUnit = (cfg) => cfg && cfg.unit;

function AdIns({ cfg }) {
  return (
    <ins
      className="kakao_ad_area"
      style={{ display: "none" }}
      data-ad-unit={cfg.unit}
      data-ad-width={cfg.width}
      data-ad-height={cfg.height}
    />
  );
}

export default function StickyAd() {
  // 마운트 시점에 한 번만 레이아웃 결정 (애드핏 스크립트는 동적 재배치를 지원하지 않음)
  const [wide] = useState(() => {
    try { return window.matchMedia(WIDE_QUERY).matches; } catch { return false; }
  });
  const rootRef = useRef(null);
  const loadedRef = useRef(false);

  const sideMode = wide && hasUnit(ADFIT_UNITS.sideLeft) && hasUnit(ADFIT_UNITS.sideRight);
  const units = sideMode
    ? [ADFIT_UNITS.sideLeft, ADFIT_UNITS.sideRight]
    : hasUnit(ADFIT_UNITS.banner) ? [ADFIT_UNITS.banner] : [];

  useEffect(() => {
    if (!units.length || loadedRef.current || !rootRef.current) return;
    loadedRef.current = true;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://t1.daumcdn.net/kas/static/ba.min.js";
    rootRef.current.appendChild(script);
    return () => {
      try {
        units.forEach((u) => window.adfit && window.adfit.destroy && window.adfit.destroy(u.unit));
      } catch (e) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!units.length) return null;

  const card = {
    background: "rgba(253, 246, 238, 0.97)",
    border: "1px solid #f0e4d8",
    borderRadius: 14,
    padding: 6,
    boxShadow: "0 4px 20px rgba(92,61,46,0.08)",
    pointerEvents: "auto",
  };

  if (sideMode) {
    return (
      <div ref={rootRef} aria-hidden={false}>
        <div style={{ position: "fixed", left: 20, top: "50%", transform: "translateY(-50%)", zIndex: 200, ...card }}>
          <AdIns cfg={ADFIT_UNITS.sideLeft} />
        </div>
        <div style={{ position: "fixed", right: 20, top: "50%", transform: "translateY(-50%)", zIndex: 200, ...card }}>
          <AdIns cfg={ADFIT_UNITS.sideRight} />
        </div>
      </div>
    );
  }

  return (
    <div
      ref={rootRef}
      style={{
        position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 200,
        display: "flex", justifyContent: "center",
        background: "rgba(253, 246, 238, 0.97)",
        borderTop: "1px solid #f0e4d8",
        padding: "6px 0 8px",
      }}
    >
      <AdIns cfg={ADFIT_UNITS.banner} />
    </div>
  );
}
